import * as React from 'react';
import './_CommentAttachments.scss';
import { ICommentAttachmentsProps } from './types';
import { CLASS_COMMENT } from '../../constants';
import { CommentAttachment } from '../CommentAttachment/CommentAttachment';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CommentAttachments`) : null;

export function CommentAttachments({
    attachments,
    isFullScreen,
    isReadonly,
    onClick,
    onDblClick,
    onDelete,
    onLoad,
    onReply
}: ICommentAttachmentsProps) {
    if (!attachments || !attachments.length) return null;
    if (analyzeRender) analyzeRender.call(`CommentAttachments`);

    return <div className={CLASS_COMMENT + '-attachments'} onDoubleClick={onDblClick}>
        {attachments.map(attachment => {
            return <CommentAttachment
                key={attachment.fileId}
                attachment={attachment}
                isActions={!isReadonly}
                isFullScreen={isFullScreen}
                onLoad={onLoad}
                onClick={onClick}
                onDelete={onDelete}
                onReply={onReply}
            />
        })}
    </div>;
}
